import { Component, EventEmitter, OnChanges, SimpleChange } from '@angular/core';
import { AuthorService } from '../../services/author.service';
import { Author } from '../../models/Author';
import { Observable } from 'rxjs/Observable';
import { map, debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-author-typeahead',
  providers: [AuthorService],
  outputs: ['authorChange'],
  inputs:['authorSelected'],
  template: `
    <ng-template #rt let-r="result" let-t="term">
      <ngb-highlight [result]="r.Name" [term]="t"></ngb-highlight>
    </ng-template>

    <label for="typeahead">Author</label>
      <div class="form-group">
        <input name="typeahead" type="text" class="form-control" (ngModelChange)="onChange($event)" [(ngModel)]="authorSelected" [ngbTypeahead]="search"
          [inputFormatter]="formatter" [resultTemplate]="rt" [editable]='false'/>
      </div>
    `
})

export class AuthorTypeaheadComponent {
  Authors: Author[] = [];
  authorSelected: Author;
  authorChange = new EventEmitter<Author>();
  constructor(private authorService: AuthorService) {
    this.loadAuthors();
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => this.Authors.filter(v => v.Name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)))

  formatter = (x: { Name: string, AuthorId: string, UserId?: string, Url?: string, UrlPhoto?: string }) => x.Name;

  loadAuthors() {
    this.authorService.GetAuthors().subscribe((authors) => {
      this.Authors = authors;
      if(Boolean(this.authorSelected) && !Boolean(this.authorSelected.Name)  ){
        this.authorSelected = this.Authors.find(x => x.AuthorId == this.authorSelected.AuthorId)
      }
        
    });
  }

  onChange(author){
    this.authorChange.emit(author);
  }
  
  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    for (let propName in changes) {
      if (propName === 'authorSelected' && Boolean(this.authorSelected) && this.Authors.length != 0) {
        this.authorSelected = this.Authors.find(x => x.AuthorId == this.authorSelected.AuthorId)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/authorTypeahead/author.typeahead.component.ts